export default __webpack_public_path__ + "images/55f57d1339822456af1eb5bf52730d1a-county_government.jpg";